// src/services/contentService.js

// Helper function to preload images
const preloadImages = (sources) => {
    return Promise.all(
        sources.map(
            (src) =>
                new Promise((resolve) => {
                    const imgLoadStartTime = performance.now();
                    const img = new Image();
                    img.src = src;
                    // Give these images a high fetch priority
                    img.fetchPriority = 'high';

                    const onFinish = () => {
                        const imgLoadEndTime = performance.now();
                        console.log(`Image loaded: ${src} in ${(imgLoadEndTime - imgLoadStartTime).toFixed(2)}ms`);
                        // Resolve regardless of success or failure to avoid blocking
                        resolve();
                    };

                    img.onload = onFinish;
                    img.onerror = onFinish;
                })
        )
    );
};

const mountStartTime = performance.now();
export const getContent = () => {
    const fetchStartTime = performance.now(); // Start timer when function is called
    return fetch(process.env.REACT_APP_CONTENT_URL)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const fetchEndTime = performance.now();
            console.log(`Data fetch from ${process.env.REACT_APP_CONTENT_URL} took: ${(fetchEndTime - fetchStartTime).toFixed(2)}ms  Time since Mount: ${(fetchEndTime - mountStartTime).toFixed(2)}ms`);
            //console.log('Received JSON data:', JSON.stringify(data, null, 2)); // Print the JSON blob
            
            if (data && Array.isArray(data.slots)) {
                const imageUrls = data.slots.map(slot => slot.imageUrl).filter(Boolean);
                return preloadImages(imageUrls).then(() => data);
            }
            return data;
        })
        .catch(error => {
            console.error("Failed to fetch or preload content:", error);
            return null;
        });
};